module.exports = __webpack_public_path__ + "media/images/riders/ADELHEID_MORATH-ce189b2c63e5f838bbf40387202b1ffd.png";